
import { API_ENDPOINTS } from "../../Api/apiEndPoints";
import axiosInstance,{CustomAxiosRequestConfig} from "../../Api/axiosInstance";




// ✅ Login API (No Token in Header)
export const login = async (params: Record<string, any>) => {
  const config: CustomAxiosRequestConfig = { skipAuth: true }; // skipAuth to skip the token
  const response = await axiosInstance.post(API_ENDPOINTS.AUTH.LOGIN, params, config);
  return response.data;
};



// ✅ Get Profile (With Token)
export const getProfile = async (params?: Record<string, any>) => {
  const response = await axiosInstance.get(API_ENDPOINTS.AUTH.GET_PROFILE);
  return response.data;
};

// ✅ Logout API (Token in Header)
export const logout = async () => {
  const response = await axiosInstance.get(API_ENDPOINTS.AUTH.LOGOUT);
  console.log("logout",response);
  return response.data;
};

// ✅ Forgot Password API (no token in header)
export const forgotPassword = async (body: { username: string }) => {
  const config: CustomAxiosRequestConfig = { skipAuth: true };
  const response = await axiosInstance.post(API_ENDPOINTS.AUTH.FORGOT_PASSWORD, body, config);
  return response.data;
};

// ✅ Reset Password API (Token is dynamic)
export const resetPassword = async (body: { otp: string; new_password: string; confirm_password: string }) => { 
 console.log("resetPassword",body);
  const config: CustomAxiosRequestConfig = { skipAuth:true };
  const response = await axiosInstance.post(API_ENDPOINTS.AUTH.RESET_PASSWORD, body, config);
  return response.data;
}

// ✅ Change Password API (Token is Header)
export const changePassword = async (body: { old_password: string; new_password: string; confirm_password: string }) => {
  const response = await axiosInstance.post(API_ENDPOINTS.AUTH.CHANGE_PASSWORD, body);
  return response.data;
}

